module.exports = __webpack_public_path__ + "img/canvas-frame-md.e0f9978.svg";